declare const window: any;

const getConfigValue = (key: string): string => {
  if (import.meta.env.PROD) {
    return window._env_[key];
  } else {
    const prefixedKey = `REACT_APP_${key}`;
    return process.env[prefixedKey] ?? '';
  }
};

export const Config = {
  API_URL: getConfigValue('API_URL'),
  REFRESH_INTERVAL: getConfigValue('REFRESH_INTERVAL'),
  PrsApi__AppConfig__Auth0__Domain: getConfigValue(
    'PrsApi__AppConfig__Auth0__Domain'
  ),
  PrsApi__AppConfig__Auth0__ClientId: getConfigValue(
    'PrsApi__AppConfig__Auth0__ClientId'
  ),
  PrsApi__AppConfig__Auth0__Audience: getConfigValue(
    'PrsApi__AppConfig__Auth0__Audience'
  ),
  ProjectService__AppConfig__ApiUrl: getConfigValue(
    'ProjectService__AppConfig__ApiUrl'
  ),
  ProjectService__AppConfig__UiUrl: getConfigValue(
    'ProjectService__AppConfig__UiUrl'
  ),
  ProjectService__AppConfig__Auth0__ClientId: getConfigValue(
    'ProjectService__AppConfig__Auth0__ClientId'
  ),
  ProjectService__AppConfig__Auth0__Audience: getConfigValue(
    'ProjectService__AppConfig__Auth0__Audience'
  ),
  ProjectService__AppConfig__Enabled:
    getConfigValue('ProjectService__AppConfig__Enabled')?.toLowerCase() ===
    'true',
  PRS_MENU_CONFIG_AUDIENCE: getConfigValue('PRS_MENU_CONFIG_AUDIENCE'),
  PRS_MENU_URL: getConfigValue('PRS_MENU_URL'),
  CDN_URL: getConfigValue('CDN_URL'),
  USER_METADATA: getConfigValue('USER_METADATA'),
  AGGrid_License: getConfigValue('AGGrid_License'),
  UI_LOG_LEVEL: getConfigValue('UI_LOG_LEVEL'),
  DISABLED_FUNCTIONALITY: getConfigValue('DISABLED_FUNCTIONALITY').split(','),
  PRS_BUILD_VERSION: getConfigValue('PRS_BUILD_VERSION'),
  ENVIRONMENT: getConfigValue('ENVIRONMENT'),
  ENVIRONMENT_BANNER_ENABLED:
    getConfigValue('ENVIRONMENT_BANNER_ENABLED')?.toLowerCase() === 'true',
  TIMEZONE_CONVERTER_LINK: getConfigValue('TIMEZONE_CONVERTER_LINK'),
  TIMEZONE_CONVERTER_PARAMS: getConfigValue('TIMEZONE_CONVERTER_PARAMS'),
  CMS_BASE_URL: getConfigValue('CMS_BASE_URL'),
};
